module.exports = __webpack_public_path__ + "assets/img/block-left-hover-6540d536.png";